import * as types from './mutation-types'


export default {
    [types.LOAD_QVCT_SURVEYS](state, data) {
        state.qvctSurveys = data
    },

    [types.LOAD_QVCT_SURVEY_STATS](state, { id, data }) {
        state.qvctSurveyStats = {
            ...state.qvctSurveyStats,
            [id]: data
        }
    },

    [types.LOAD_QVCT_SURVEY_OPINION](state, { id, data }) {
        state.qvctSurveyOpinion = {
            ...state.qvctSurveyOpinion,
            [id]: data
        }
    },


    [types.LOAD_QVCT_SURVEY_QUESTIONS](state, {id, questions}) {
        state.qvctSurveyQuestions = {...state.qvctSurveyQuestions, [id]: questions}
    },

    [types.LOAD_QVCT_SURVEY](state, data) {
        const index = state.qvctSurveys.findIndex(e => e.id === data.id);
        if (index !== -1) {
            state.qvctSurveys.splice(index, 1, data);
        }else {
            state.qvctSurveys.push(data);
        }
    },

    [types.LOAD_QVCT_SURVEYS_CATEGORIES_WITHOUT_CHILDREN](state, data) {
        state.qvctSurveysCategoriesWithoutChildren = data
    },

    [types.LOAD_QVCT_SURVEYS_ROOT_CATEGORIES](state, data) {
        state.qvctSurveysRootCategories = data
    },


    [types.LOAD_QVCT_SURVEYS_ANSWER_TYPE](state, data) {
        state.qvctSurveysAnswersType = data
    },

    [types.ADD_QVCT_SURVEY](state, data) {
        state.qvctSurveys.push(data)
    },

    [types.ADD_QVCT_SURVEY_QUESTION](state, {id, questions}) {
        let qvctSurveyQuestions = state.qvctSurveyQuestions[id] || []
        questions.forEach((question) => {
            const index = qvctSurveyQuestions.findIndex(e => e.id === question.id);

            if (index !== -1) {
                qvctSurveyQuestions.splice(index, 1, question);
            }else {
                qvctSurveyQuestions.push(question);
            }

        })
        state.qvctSurveyQuestions = {...state.qvctSurveyQuestions, [id]: qvctSurveyQuestions}
    },

    [types.LOAD_QVCT_SURVEY_QUESTION](state, data) {
        const index = state.qvctSurveys.findIndex(e => e.id === data.id);
        if (index !== -1) {
            state.qvctSurveys.splice(index, 1, data);
        }else {
            state.qvctSurveys.push(data);
        }
    },

    [types.REMOVE_QVCT_SURVEY_QUESTION](state, {surveyId, id}) {
        let qvctSurveyQuestions = state.qvctSurveyQuestions[surveyId] || []
        qvctSurveyQuestions = qvctSurveyQuestions.filter(x => x.id !== id)
        state.qvctSurveyQuestions = {...state.qvctSurveyQuestions, [surveyId]: qvctSurveyQuestions}
    },

    [types.LOAD_QVCT_SURVEY_FROM_FOR_RESPONSE](state, data) {
        state.qvctSurveyForResponse = data
    },

    [types.LOAD_QVCT_SURVEY_RESPONSES](state, {id, responses}) {
        state.qvctSurveyResponses = {...state.qvctSurveyResponses, [id]: responses}
    },


    [types.LOAD_QVCT_SURVEY_STATUS](state, data) {
        state.qvctSurveyStatus = data
    },



}
